module.exports = __webpack_public_path__ + "media/images/favicon/primary/ms-icon-150x150-3a0b6b50a1302c2a35d6824e4ffc565c.png";